import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # MissionHistoryDetail
 *
 * 미션 히스토리 상세 모델
 */

export const UserScenPrgs = types.model('UserScenPrgs', {
  order: types.string,
  title: types.string,
  complete_yn: types.string,
});
type TUserScenPrgs = Instance<typeof UserScenPrgs>;
export interface IUserScenPrgs extends TUserScenPrgs {}
export const createUserScenPrgs = () => types.optional(UserScenPrgs, {} as TUserScenPrgs);

export const MissionHistoryDetail = types
  .model('MissionHistoryDetail')
  // --------------------------------------------------------------------------
  .props({
    target_week: types.number,
    user_scen_prgs_list: types.array(UserScenPrgs),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model missionHistoryDetail --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IMissionHistoryDetail;
      (Object.keys(newProps) as TMissionHistoryDetailKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMissionHistoryDetail = Instance<typeof MissionHistoryDetail>;
type TMissionHistoryDetailSnapshot = SnapshotOut<typeof MissionHistoryDetail>;

export interface IMissionHistoryDetail extends TMissionHistoryDetail {}
export type TMissionHistoryDetailKeys = keyof TMissionHistoryDetailSnapshot & string;
export interface IMissionHistoryDetailSnapshot extends TMissionHistoryDetailSnapshot {}
export const createMissionHistoryDetail = () =>
  types.optional(MissionHistoryDetail, {} as TMissionHistoryDetail);
